import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import styles from './common.module.scss';

import { FieldNumber, FieldText } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  const action = useMemo(() => {
    switch (command.data.action) {
      case 0:
        return 'Release';
      case 1:
        return 'Grab';
      default:
        break;
    }
  }, [command.data.action]);

  return (
    <div className={cx('container')}>
      <label>
        Gripper Instance Number
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.gripper} readOnly />
        </div>
      </label>
      <label>
        Action
        <div className={cx('fieldWrapper')}>
          <FieldText value={action} readOnly />
        </div>
      </label>
    </div>
  );
};

export default Item;
